// extracted by mini-css-extract-plugin
module.exports = {"component":"styles__component--1Yg3b","horizontal":"styles__horizontal--1Ae6A","vertical":"styles__vertical--3MZQA"};